export function selectLastStripeValidation(state) {
  return state.stripe.revalidatedAt;
}

export function selectUsedStripeTokens(state) {
  return state.stripe.usedTokens;
}

export function selectStripe(state) {
  return state.stripe.stripe;
}

export function selectStripeIsLoading(state) {
  return state.stripe.isLoading;
}
